export default __webpack_public_path__ + "static/media/default.ecdd4a14.png";